import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { NdtHubBase } from '../base/ndt-hub.base';
import { NdtHubConnectionService } from '../ndt-hub-connection.service';

@Injectable()
export abstract class CallDetailsHubBase extends NdtHubBase {
   protected autoRefresh$: Observable<boolean>;
   protected destroyed$ = new Subject<void>();

   constructor(ndtHubService: NdtHubConnectionService, protected store: Store) {
      super(ndtHubService);
   }

   protected abstract init(selector: Observable<boolean>): void;

   override ngOnDestroy(): void {
      this.destroyed$.next();
      this.destroyed$.complete();
      super.ngOnDestroy();
   }

   registerCallDetailEvents(accountId: number | null, isSystemUser: boolean): void {
      this.ndtHubService.connected.subscribe(() => {
         this.ndtHubService.connection.invoke('JoinCallDetailsGroup', accountId, isSystemUser);
      });
   }
}
